import styles from "../../../styles/Components/new-dashboard/top-community-bots/CommunityBotItem.module.css";
import { BsBarChart, BsCashCoin, BsFillPersonCheckFill } from "react-icons/bs";
import { IoCopy, IoSpeedometerOutline } from "react-icons/io5";
import { AiOutlineLineChart } from "react-icons/ai";
import { CiBitcoin } from "react-icons/ci";
import { FaArrowTrendUp } from "react-icons/fa6";
import { message, Typography } from "antd";
import { formatPrice } from "../../../utility/helper";
import React, { useState } from "react";
import { returnDataForCreateBot } from "../../../utility/formatter-helper";
import { useSelector } from "react-redux";
import IntegratedExchangesModal from "../../bot/bot-configuration/top-bots/IntegratedExchangesModal";
import BotDetailModal from "../bot-performance/BotDetailModal";
import BotIcon from "../../../ui/icons/BotIcon";
import { PiChartLineUpBold } from "react-icons/pi";
import { RiSearch2Fill } from "react-icons/ri";
import { HiCurrencyDollar } from "react-icons/hi2";
import { MdMoreHoriz } from "react-icons/md";

const { Text } = Typography;

function CommunityBotItem({ data = {}, divisionFactor }) {
  const {
    botState: { createBotLoading },
  } = useSelector((state) => state);

  const {
    bot_name: name,
    risk_apetite: risk,
    profit_percent: profit,
    budget_usd: budget,
    win_rate: winRate,
    market_type: market,
    leverage,
    number_of_coins: coins,
  } = data;

  const [showExchangeModal, setShowExchangeModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);

  const copyBotHandler = () => {
    if (createBotLoading)
      return message.info("Please wait to finish the process.");

    setShowExchangeModal(true);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.botIcon}>
          <BotIcon />
        </div>
        <div className={styles.botInfo}>
          <h4>{name}</h4>
          <div className={styles.profit}>
            <span>
              <PiChartLineUpBold />{" "}
              {`Profit (${divisionFactor}Month${divisionFactor > 1 ? "s" : ""}):`}
            </span>
            <Text
              type={profit / divisionFactor > 0 ? "success" : "danger"}
              strong
            >
              {(profit / divisionFactor)?.toFixed(2)}%
            </Text>
          </div>
        </div>
      </div>
      <div className={styles.botDetails}>
        <div className={styles.botDetail}>
          <span className={styles.label}>
            <RiSearch2Fill size={15} color="#0c4cfc" />
            Risk Appetite:
          </span>
          <span>{risk}</span>
        </div>
        <div className={styles.botDetail}>
          <span className={styles.label}>
            <HiCurrencyDollar size={15} color="#0c4cfc" />
            Budget: ${formatPrice(budget)}
          </span>
          <span className={styles.winRate}>Win Rate: {winRate}</span>
        </div>
      </div>

      <div className={styles.botMeta}>
        <span>
          <AiOutlineLineChart color="#0c4cfc" />
          {market}
        </span>
        <span>
          <CiBitcoin color="#0c4cfc" /> Coins: {coins}
        </span>
        <span>
          <BsBarChart color="#0c4cfc" />
          Leverage: {leverage}x
        </span>
      </div>
      <div className={styles.actionBtns}>
        <span
          className={`${styles.btn} ${styles.secondary}`}
          onClick={() => setShowDetailModal(true)}
        >
          View Details
          <MdMoreHoriz />
        </span>
        <span
          className={`${styles.btn} ${styles.primary}`}
          onClick={copyBotHandler}
        >
          Copy Bot
          <IoCopy />
        </span>
      </div>

      {showExchangeModal && (
        <IntegratedExchangesModal
          show={showExchangeModal}
          onClose={setShowExchangeModal}
          data={returnDataForCreateBot(data)}
        />
      )}

      {showDetailModal && (
        <BotDetailModal
          data={data}
          setShow={setShowDetailModal}
          visible={showDetailModal}
          showChart={false}
        />
      )}
    </div>
  );
}

export default CommunityBotItem;
